import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  cardWrapper: {
    margin: '24px 40px',
    padding: '20px'
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '10px 40px 16px',
    height: '100%',
    flexWrap: 'wrap'
  },
  subHeaderWrapper: {
    backgroundColor: '#F7F7F7',
    padding: '0.5rem',
    color: '#F37320',
    fontWeight: 'bold',
    textAlign: 'left',
    fontSize: '18px',
  },
  innerContainer: {
    padding: '10px 20px',
  },
  paper: {
    maxHeight: '200px',
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: '5px'
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#c3c3c3',
      width: '5px'
    }
  },
  title: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '38px'
  },
  formContainer: {
    margin: '0 40px',
    padding: '20px',
  },
  buttonContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start'
  },
  buttons: {
    width: 'auto',
    margin: '10px 0'
  },
  primaryButton: {
    color: 'white',
    marginRight: '20px'
  },
  userHeaderWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: '20px 20px',
  },
  mr4: {
    marginRight: '10px',
  },
  mt2: {
    marginTop: '20px',
  },
  mt4: {
    marginTop: '60px',
  },
  cardTitle: {
    marginBottom: '15px',
    fontSize: '20px',
    color: '#545456'
  },
  submitButton: {
    width: '150px',
    color: 'white',
    float: 'right',
    margin: '5px'
  },
  cancelButton: {
    maxWidth: '220px',
    float: 'right',
    margin: '5px'
  },
  hr: {
    borderTop: '1px solid #D8D8D8',
  },
  input: {
    '@media (min-width: 3000px)': {
      '& svg': {
        top: 'calc(50% - 25px)'
      }
    }
  },
  customFormLabel: {
    fontSize: '15px'
  },
  zipWrapper: {
    display: 'flex'
  },
  table: {
    width: '50%',
    margin: '0 auto',
    '& tr': {
      display: 'flex',
      width: '100%',
      borderBottom: '1px solid rgba(224, 224, 224, 1)',
    },
    '& th': {
      display: 'flex',
      padding: '16px',
      backgroundColor: '#335977',
      width: '100%',
      color: '#FFE784',
      fontWeight: '400',
      fontSize: '14px',
      fontFamily: 'Arial'
    },
    '& td': {
      width: '100%', 
      color: 'black',
      padding: '16px',
      fontSize: '14px',
      fontFamily: 'Arial',
      fontWeight: '400',
    }
  },
  tableWrapper: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto',
  },
  widePopup: {
    maxWidth: '1000px'
  },
  formContentBox: {
    padding: '20px',
    maxHeight: '70vh',
    overflowY: 'auto'
  },
  formHeaderContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  closeIcon: {
    color: '#545456'
  },
  pointer: {
    cursor: 'pointer'
  },
  formFieldsContainer: {
    padding: '0px 0px 0px 30px'
  },
  certificateUploadBox: {
    marginTop: '30px',
    padding: '20px',
    backgroundColor: '#f5f5f5',
    borderRadius: '4px'
  },
  certificateTitle: {
    marginTop: 0,
    marginBottom: '10px',
    color: '#335977'
  },
  certificateNote: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '15px'
  },
  passwordFieldContainer: {
    marginBottom: '15px'
  },
  uploadButtonsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  hiddenFileInput: {
    display: 'none'
  },
  fileInputLabel: {
    cursor: 'pointer'
  },
  formButtonsContainer: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  errorText: {
    color: 'red'
  },
  profileLink: {
    color: 'black',
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  whiteTooltip: {
    backgroundColor: '#ffffff !important',
    color: '#333 !important',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15) !important',
    padding: '10px 14px !important'
  },
  whiteTooltipArrow: {
    color: '#ffffff !important'
  },
  tooltipContent: {
    fontSize: '12px',
    lineHeight: '1.6'
  },
  infoIcon: {
    fontSize: '18px',
    marginLeft: '8px',
    cursor: 'pointer',
    verticalAlign: 'middle',
    color: '#666'
  }
}))

export { useStyles }